function Typography() {
  return {
    fontFamily: '"Comfortaa", cursive',
  };
}

export default Typography;
